<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section">
            <v-container>
                <tit-primary
                sc="Application status"
                tit="신청 현황">
                </tit-primary>

                <v-data-table v-bind="{ items, headers }" hide-default-footer disable-filtering disable-sort class="v-data-table--default">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                    <template #[`item.state`]="{ item }">
                        <v-chip :color="stateColor(item)" label><span class="white--text">{{ stateText(item) }}</span></v-chip>
                        <!-- <v-chip label dark :color="stateColor(item)" class="mw-100px w-100 d-flex justify-center">{{ stateText(item) }}</v-chip> -->
                    </template>
                    <template #[`item.cancel`]="{ item }">
                        <v-btn :disabled="!isCancelable(item)" @click="cancel(item)" outlined small rounded elevation="0" color="grey" class="v-btn--table"><span class="grey-dark--text">신청취소</span></v-btn>
                        <!-- <v-btn elevation="0" :disabled="!isCancelable(item)" small color="pink lighten-1" class="w-80px w-md-100px w-lg-120px" @click="cancel(item)">신청취소</v-btn> -->
                    </template>
                    <template #footer> <pagination-component :value="page" :count="pageCount" @input="(page) => $router.push({ query: { page } })" /> </template>
                </v-data-table>
            </v-container>
        </section>
        
    </client-page>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import { RENTAL_SCHEDULE_STATES } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import PaginationComponent from "@/components/client/control/pagination-component.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

let headers = [
    { width: "5%", align: "center", text: "번호", value: "index" },
    { width: "14%", align: "center", text: "신청일시", value: "createdAt", formatter: (value) => value?.toDateTime?.() || value },
    { width: "auto", align: "center", text: "설비명", value: "subject.name" },
    { width: "14%", align: "center", text: "예약일", value: "date", formatter: (value) => value?.toDate?.() || value },
    { width: "12%", align: "center", text: "예약시간", value: "times", formatter: (value = []) => (value.length ? value.map((time) => `${time}시`).join(", ") : "종일") },
    { width: "10%", align: "center", text: "신청", value: "state" },
    { width: "10%", align: "center", text: "취소", value: "cancel" },
];

export default {
    components: {
        ClientPage,
        SubVisual,
        MypageNavigation,
        PaginationComponent,
		TitPrimary,
    },
    data: () => ({
        limit: 10,

        summary: { totalCount: 0 },
        requests: [],

        headers,
        RENTAL_SCHEDULE_STATES,
    }),
    computed: {
        items() {
            return this.requests.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index, isDone: dayjs().isAfter(item.datetime) }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
    },
    mounted() {
        this.reroute().then(this.search);
    },
    watch: {
        page() {
            this.search();
        },
    },
    methods: {
        async reroute() {
            if (!this.$store.state.accessToken) this.$router.push("/login");
        },
        async search() {
            let { skip, limit } = this;
            let { summary, requests } = await api.v1.me.rental.requests.gets({ headers: { skip, limit } });

            this.summary = summary;
            this.requests = requests;
        },
        async cancel({ _id, subject, schedules }) {
            let go = confirm(`아래 예약에 대한 신청을 취소하시겠습니까?\n\n설비명: ${subject?.name}`);
            if (go) {
                schedules = await Promise.all(
                    schedules.map(async (schedule = {}) => {
                        let { _id } = schedule;
                        try {
                            return { ...((await api.v1.me.rental.schedules.putCancel({ _id }))?.schedule || schedule), success: true };
                        } catch (error) {
                            console.error(error);
                            return { ...schedule, success: false };
                        }
                    })
                );
                let { request } = await api.v1.me.rental.requests.putCancel({ _id });
                this.update(request);
            }
        },
        update(item) {
            let index = this.requests.findIndex(({ _id }) => _id == item._id);
            if (index > -1) {
                this.requests.splice(index, 1, item);
            } else {
                this.requests.splice(0, 0, item);
            }
        },
        stateColor({ state, isDone }) {
            if (state == RENTAL_SCHEDULE_STATES.APPROVED.value && isDone) return "grey";
            switch (state) {
                case RENTAL_SCHEDULE_STATES.APPLIED.value:
                    return "accent";
                case RENTAL_SCHEDULE_STATES.CANCELED.value:
                    return "secondary";
                case RENTAL_SCHEDULE_STATES.APPROVED.value:
                    return "primary";
                case RENTAL_SCHEDULE_STATES.REJECTED.value:
                    return "pink lighten-1";
            }
        },
        stateText({ state, isDone }) {
            if (state == RENTAL_SCHEDULE_STATES.APPROVED.value && isDone) return "종료";

            switch (state) {
                case RENTAL_SCHEDULE_STATES.APPLIED.value:
                case RENTAL_SCHEDULE_STATES.CANCELED.value:
                case RENTAL_SCHEDULE_STATES.REJECTED.value:
                case RENTAL_SCHEDULE_STATES.APPROVED.value:
                    return RENTAL_SCHEDULE_STATES[state]?.text;
            }
        },
        isCancelable(item) {
            if (item.state == RENTAL_SCHEDULE_STATES.CANCELED.value) return false;
            if (item.state == RENTAL_SCHEDULE_STATES.REJECTED.value) return false;
            if (dayjs().isAfter(item.datetime)) return false;
            return true;
        },
        isAttendable(item) {
            return item.state == RENTAL_SCHEDULE_STATES.APPROVED.value;
        },
    },
};
</script>
